/**
 * This file encapsulates the react-dnd functionality needed for dragging and dropping.
 */

import _ from 'underscore';
let lastToId = null;
// let lastFromId = null;

// let dragOptions = {
//   arePropsEqual: function(props1, props2) {
//     return (props1.node.id === props2.node.id);
//  }
// };

const isInDecendants = (node, compareNode) => {
  let result = false;
  if (node.nodes) {
    _.each(node.nodes, child => {
      if (child.id === compareNode.id) {
        result = true;
      } else {
        result = result || isInDecendants(child, compareNode);
      }
    });
  }
  return result;
};
export const treeNodeTarget = {
  hover(props, incomingMonitor) {
    const monitor = incomingMonitor;
    if (monitor.isOver()) {
      return false;
    }
    const toNode = props.node;
    const item = monitor.getItem();
    if (!_.isUndefined(item) && !_.isNull(item)) {
      const fromNode = item.node;
      // can't drag to one of the children of this node.
      if (isInDecendants(fromNode, toNode)) {
        return false;
      }
      if (!_.isEqual(props.target, toNode) && toNode.id !== fromNode.id && toNode.id !== lastToId) {
        // lastFromId = fromNode.id;
        lastToId = toNode.id;
        const dragIndex = item.index;
        const hoverIndex = props.index;

        /*
           console.log('call count ' + called + ' target.id ' +
           props.target.id +
           ' toNodeId ' + toNode.id +
           ' fid ' + fromNode.id);
           */
        // Note: we're mutating the monitor item here!
        // Generally it's better to avoid mutations,
        // but it's good here for the sake of performance
        // to avoid expensive index searches.
        monitor.getItem().index = hoverIndex;
        if (props && props.onTargetHover) {
          props.onTargetHover(fromNode, toNode, dragIndex, hoverIndex);
        }
      }
    }
    return true;
  },
  drop(props, monitor) {
    const item = monitor.getItem();
    if (!_.isUndefined(item) && !_.isNull(item) && !monitor.didDrop()) {
      // Not sure if these monitor events need to be run,
      // but the output appears to be unused
      // const isOverCurrent = monitor.isOver({ shallow: false});
      // const isOver = monitor.isOver();

      const toNode = props.node;
      const dragIndex = item.index;
      const fromNode = item.node;
      const hoverIndex = props.index;
      // can't drag to one of the children of this node.
      if (isInDecendants(fromNode, toNode)) {
        return;
      }

      // Time to actually perform the action
      if (props.onTargetHover) {
        props.onTargetHover(null, null);
      }
      props.onMove(fromNode, toNode, dragIndex, hoverIndex);
    } else if (props.onTargetHover) {
      props.onTargetHover(null, null);
    }
  }
};
export const treeNodeSource = {
  canDrag() {
    return true;
  },
  beginDrag(props) {
    return {
      text: props.name,
      node: props.node
    };
  },
  endDrag(props) {
    if (props.onTargetHover) {
      props.onTargetHover(null, null);
    }
  }
};
export const dragCollect = (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  isDragging: monitor.isDragging()
});
export const dropCollect = (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isOver: monitor.isOver(),
  isOverCurrent: monitor.isOver({
    shallow: true
  })
});